export default __webpack_public_path__ + "static/media/noimage.d48886a9.png";